import { Cross, DocumentEdit } from '@sravni/react-icons';

export const IconHelper = {
  earlyRepayment: Cross,
  documents: DocumentEdit,
};
